import React from "react";
import { useLocation } from "react-router";
import {Link, NavLink} from "react-router-dom";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import * as Icons from "assets/icons";

import config from "config";

import Container from "components/Container";

import cls from "./Header.module.scss";
import LanguageSelect from "./components/LanguageSelect";

const Header = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const linkClassName = ({isActive}) => `${cls.siteName} ${isActive ? cls.active : ""}`;

  return (
    <header
      className={cx(
        cls.header,
        location.pathname !== "/" && cls["header-static"],
      )}>
      <Container>
        <div className={cls.content}>
          <div className={cls.left}>
            <Link className={cls.logo} to="/">
              <Icons.Logo size={40} />

              <span className={cls.name}>
                O’zbekiston Respublikasi <br /> Adliya vazirligi
              </span>
            </Link>

            <nav>

              <NavLink className={linkClassName} to="/">
                {t("register_of_state_functions")}
              </NavLink>
              <span className={cls.line} />
              <NavLink className={linkClassName} to="/service-register">
                {t("register_of_state_services")}
              </NavLink>
              <span className={cls.line} />
              <NavLink className={linkClassName} to="/mandatory-requirement/register">
                {t("mandatory-requirements")}
              </NavLink>
            </nav>

            {/*<span className={cls.line} />*/}



          </div>
          <div className={cls.right}>
            <LanguageSelect />
            <a
              className={cls.enter}
              rel="noreferrer"
              href={config.app.partner_url}
              target="_blank">
              {t("action_enter")}
            </a>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
